import React, { useState } from 'react';
import './CheckboxList.css'; // נשתמש בעיצוב בסיסי כאן

const options = [
  { id: 'abs', label: 'ABS' },
  { id: 'hands-free', label: 'דיבורית' },
  { id: 'electric-mirror', label: 'מראות חשמליות' },
  { id: 'power-steering', label: 'הגה כח' },
  { id: 'sound-system', label: 'מערכת שמע' },
  { id: 'magnesium-wheel', label: 'גלגל מגנזיום' },
  { id: 'top-window', label: 'חלון בגג' },
  { id: 'belt-sensors', label: 'חיישני חגורה' },
  { id: 'camera', label: 'מצלמת רוורס' },
  { id: 'upholstery', label: 'ריפוד' },
  { id: 'air-conditioner', label: 'מערכת מיזוג' },
  { id: 'electric-windows', label: 'חלונות חשמליים' },
  { id: 'multimedia', label: 'מערכת מולטימדיה' },
  { id: 'mobilai', label: 'מערכת מובילאיי' },
];

const AccesoriesCheckList = ({ selected, setSelected, disabled }) => {
  const handleChange = (id) => {
    setSelected((prev) =>
      prev?.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id]
    );
  };

  return (
    <div className="checkbox-list">
      {options.map(({ id, label }) => (
        <label key={id} className="checkbox-item">
        <input
  type="checkbox"
  checked={selected?.includes(id)}
  onChange={() => !disabled && handleChange(id)}
  disabled={disabled}
/>

          <span className="custom-checkbox" />
          {label}
        </label>
      ))}
    </div>
  );
};

export default AccesoriesCheckList;
